import React from 'react'

import { useIsDesktop } from '@rewardops/ui'

const ResponsiveComponent = ({
  mobileComponent,
  desktopComponent,
}: {
  mobileComponent: React.ReactNode
  desktopComponent: React.ReactNode
}) => {
  const isDesktop = useIsDesktop()

  return (
    <>
      {!isDesktop && mobileComponent}
      {isDesktop && desktopComponent}
    </>
  )
}

export default ResponsiveComponent
